import { createContext, useContext, type ReactNode } from 'react';
import { useI18n } from '@cdn/i18n';
import type { Docs, Page } from './docs';

const Context = createContext<Docs | undefined>(undefined);

export function DocsProvider({ docs, children }: { docs: Docs; children: ReactNode }) {
	return <Context.Provider value={docs}>{children}</Context.Provider>;
}

export function useDocs(): Docs {
	const docs = useContext(Context);
	if (!docs) throw new Error('useDocs needs a DocsProvider');
	return docs;
}

/**
 * Contextual link from a screen to its page of the public documentation, in the selected language.
 */
export function LearnMore({ page, children }: { page: Page; children?: ReactNode }) {
	const { t, locale } = useI18n();
	const docs = useDocs();
	return (
		<a
			href={docs.page(page, locale.code)}
			target="_blank"
			rel="noreferrer"
			className="text-link underline underline-offset-4 hover:no-underline"
		>
			{children ?? t('docs.learn')}
			<span className="sr-only"> {t('docs.external')}</span>
		</a>
	);
}
